"use client";

import { useSelector } from "react-redux";
import TopLoadingProgress from "./TopLoadingProgress";

export default function GlobalLoadingProgress() {
  const isLoading = useSelector((state) => state.loading.loadingCount > 0);

  return isLoading ? <TopLoadingProgress /> : null;
}
